const HOME_MESSAGES = {
  HEADING: 'Welcome to Worksana',
  SUB_HEADING: 'Create and Manage Schedules',
  BTN_LABEL: 'Go to Login',
  BTN_DASHBOARD_LABEL: 'Go to Scheduling Dashboard '
}

export default HOME_MESSAGES
